
import React, { useEffect, useState } from "react";
import { FlatList, ImageBackground, Text, TouchableOpacity, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { getCcqStatus } from "../../redux/actions/preReferencing";
import AppBanner from "../appBanner/index";
import getPlatformType, { getImage } from "../../helpers/getPlatform";
import { navigateAction } from "../../helpers/navigationHelpers";
import { tenantActions } from "../openFlow/openFlowRedux/tenant.actions";
import BackGroundGenerator from "../LandingPages/common/BackGroundGenerator";
import { getHomeIframeParams, getProfile, LogoutApi, updateProfile } from "../../redux/actions/auth";
import { useIsFocused } from "@react-navigation/native";
import ODSWelcomeTile from "../../../openbrix-design-system/ui/atoms/ODSTiles/WelcomeTile";
import ODSTenancyTile from "../../../openbrix-design-system/ui/atoms/ODSTiles/TenancyTile";
import ODSDashboardTiles from "../../../openbrix-design-system/ui/molecules/DashboardTiles";
import { getNotificationsCount } from "../../redux/actions/notification";
import { HOME_BASE_URL, SERVER_URL, URL } from "../../helpers/connectionHelpers";
import { RegisterCard } from "../tlyfePages/styles";
import Regex from "../../helpers/regex";
import ODSCombobox from "../../../openbrix-design-system/ui/atoms/ODSComboBox";
import { types } from "../../redux/actionTypes";
import { ODSText } from "../../../openbrix-design-system/ui/atoms/ODSText";
import { ODSInput } from "../../../openbrix-design-system/ui/atoms/ODSInput";
import ODSButton from "../../../openbrix-design-system/ui/atoms/ODSButton/index.native";
import { useTheme } from "@emotion/react";
import ODSCheckbox from "../../../openbrix-design-system/ui/atoms/ODSCheckbox";
import Wrapper from "../tlyfePages/Wrapper";
import { MobileValidation, NameValidation } from "../../helpers/validation";
const HeaderWeb = require('../../../openbrix-design-system/images/tlyfe-pages/i-desktop.png');
const HeaderTab = require('../../../openbrix-design-system/images/tlyfe-pages/i-tab.png');
const HeaderMobile = require('../../../openbrix-design-system/images/tlyfe-pages/login-mobile.png');
import { buttonPressEvent, identifyUser, trackLogout } from "../../helpers/analytics";
import CustomPopUp from "../../commonComponents/customPopUp/customPopUp.web";
import { tenancy_status } from "../../helpers/objectHelpers";
import { LinearGradient } from "expo-linear-gradient";
import ODSHomeIframe from "../../../openbrix-design-system/ui/atoms/ODSTiles/ODSHomeIframe";


const Dashboard = (props) => {

  const { navigation } = props;
  const dispatch = useDispatch();
  const { colors } = useTheme();
  const [type, setType] = useState("web");
  const layout = getPlatformType();
  const [tiles, setTiles] = useState([]);
  const [flowId, setFlowId] = React.useState(null);
  const [preQualData, setPreQualData] = React.useState([]);
  const [flowIdInfo, setFlowIdInfo] = React.useState(null);
  const globalState = useSelector((state) => state?.tenant);
  const [filterButton, setFilterButton] = React.useState([]);
  const [isLoginTypeTds, setIsLoginTypeTds] = React.useState(false);
  const [postcode, setPostcode] = useState("");
  const [postcodeErrorMsg, setPostcodeErrorMsg] = useState("");
  const [postcodeData, setPostcodeData] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [selectedPostcode, setSelectedPostcode] = useState("");
  const [addressLine1ErrorMsg, setAddressLine1ErrorMsg] = useState("");
  const [cityErrorMsg, setCityErrorMsg] = useState("");
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [profileChecked, setProfileChecked] = useState(false);
  const [selectedPostcodeErrorMsg, setSelectedPostcodeErrorMsg] = useState("");
  const [state, setState] = useState({
    tncStatus: false,
    contactStatus: false,
    buyerEmail: '',
    buyerPassword: '',
    buyerEmailErrorMessage: '',
    buyerPasswordErrorMessage: '',
    selectedTab: 'Tab1',
    buyerFirstName: '',
    buyerLastName: '',
    is_tenant_concierge_service: true
  });

  const [hoverStartTime, setHoverStartTime] = useState(null);
  const [tdsRoute, setTdsRoute] = useState("TDS Search Deposit");
  const profile = useSelector((state) => state.authReducer?.profile);
  const iFrameParams = useSelector((state) => state.authReducer?.iFrameParams);

  const userData = useSelector((state) => state.authReducer?.profile?.data?.appUser);
  const {
    affordability,
    fcc_pre_reference,
    id_verification,
    right_to_rent,
    tenant_info
  } = preQualData;
  const tdsLocationSelected = useSelector((state) => state.appReducer?.tdsLocationSelected);


  // Add this selector to get the searched addresses
  const searchedAddresses = useSelector((state) => state.tenant?.searchedAddresses);


  const getAddress = (address) => {
    let displayUrl = "";

    if (address?.SUB_BUILDING) {
      displayUrl += address.SUB_BUILDING + ", ";
    }
    if (address?.BUILDING_NAME) {
      displayUrl += address.BUILDING_NAME + ", ";
    }
    if (address?.BUILDING_NUMBER) {
      displayUrl += address.BUILDING_NUMBER + ", ";
    }
    if (address?.STREET_NAME) {
      displayUrl += address.STREET_NAME + ", ";
    }
    if (address?.LOCALITY) {
      displayUrl += address.LOCALITY + ", ";
    }

    displayUrl = displayUrl.trim().replace(/,$/, '');

    return displayUrl;
  };

  // Add this useEffect to handle the address search results
  useEffect(() => {
    if (searchedAddresses && Array.isArray(searchedAddresses)) {
      setPostcodeData(
        searchedAddresses.map(e => {
          return {
            value: JSON.stringify(e),
            label: getAddress(e)
          }
        })
      )
    } else {
      setPostcodeData([]);
    }
  }, [searchedAddresses]);

  const focus = useIsFocused();
  useEffect(() => {
    fetchTiles();
  }, [focus]);
  const fetchTiles = () => {
    dispatch(tenantActions.getTilesData((data) => {
      if (data) {
        if (data[0].card == "OpenFlow" || data[0].card == "HomeBox") {
          setTiles([...data]);
        } else {
          setTiles([{}, ...data]);
        }
      }
    }));
  };
  useEffect(() => {
    dispatch(getHomeIframeParams());
    dispatch(getProfile((data) => {
      if (!data?.profile_completion_required && data?.subscription_selection_required) {
        navigation.reset({
          index: 0,
          routes: [{ name: 'TlyfePlans', params: { onRegistration: true } }],
        });
        // Do NOT set profileChecked — keep dashboard hidden during redirect
        return;
      }
      setProfileChecked(true);
      if (data?.appUser?.primary_tag !== "tds" && data?.appUser?.primary_tag !== "TDS")
        setState({
          ...state,
          buyerFirstName: data?.first_name,
          buyerFirstNameErrorMsg: "",
          buyerLastName: data?.last_name,
          buyerLastNameErrorMsg: ""
        });
    }));
    dispatch(getNotificationsCount());
    dispatch(getCcqStatus(true));
    dispatch(tenantActions.getPreQualificationStatus());
    return () => {
      setHoverStartTime(0);
    };
  }, []);
  useEffect(() => {
    if (profile?.data?.isActiveOpenflow) {
      dispatch(tenantActions.getFlowInfo());
    }
  }, [profile?.data?.isActiveOpenflow]);
  useEffect(() => {
    if (profile?.data?.appUser?.primary_tag == "tds" || profile?.data?.appUser?.primary_tag == "TDS" || profile?.data?.appUser?.registration_refrence == "tds") {
      setIsLoginTypeTds(true);
    } else {
      setIsLoginTypeTds(false)
    }
    if (profile?.data?.appUser?.opbrix_id) {
      identifyUser(profile?.data?.appUser?.opbrix_id)
    }
  }, [profile?.data?.appUser?.primary_tag, profile?.data?.appUser?.registration_refrence]);

  useEffect(() => {
    setFlowId(globalState?.flowIdInfo?.openflow_id);
    setFlowIdInfo(globalState?.flowIdInfo);

    const ListArray = [
      {
        buttonStatus: "tenancy_status",
        routeKey: "TenantDetails",
        id: "tenantDetails",
        actionStatus: globalState?.flowIdInfo?.tenancy_status,
        button_text: globalState?.flowIdInfo?.tenancy_button_text,
        navigate: () => navigation.navigate("TenantDetails")
      },
      {
        buttonStatus: "doc_status",
        routeKey: "PropertyDocs",
        id: "landlord-PropertyDocument",
        actionStatus: globalState?.flowIdInfo?.doc_status,
        button_text: globalState?.flowIdInfo?.doc_button_text,
        navigate: () => navigation.navigate("PropertyDocs")
      },
      {
        buttonStatus: "rental_offer_status",
        routeKey: "RentalOffers",
        id: "rentalOffer",
        actionStatus: globalState?.flowIdInfo?.rental_offer_status,
        button_text: globalState?.flowIdInfo?.rental_offer_button_text,
        navigate: () => navigation.navigate("RentalOffers")
      },
      {
        buttonStatus: "holding_deposit_status",
        routeKey: "HoldingDeposit",
        id: "holdingDeposit",
        actionStatus: globalState?.flowIdInfo?.holding_deposit_status,
        button_text: globalState?.flowIdInfo?.holding_deposit_button_text,
        navigate: () => navigation.navigate("HoldingDeposit")
      },
      {
        buttonStatus: "verification_status",
        routeKey: "IdAndReference",
        id: "id-Referncing",
        actionStatus: globalState?.flowIdInfo?.verification_status,
        button_text: globalState?.flowIdInfo?.verification_button_text,
        navigate: () => navigation.navigate("IdAndReference")
      },
      {
        buttonStatus: "landlord_status",
        routeKey: "ReviewAPT",
        id: "tenancyAgreement",
        actionStatus: globalState?.flowIdInfo?.landlord_status,
        button_text: globalState?.flowIdInfo?.landlord_button_text,
        navigate: () => navigation.navigate("ReviewAPT")
      },
      {
        buttonStatus: "move_in_status",
        routeKey: "DepositInfo",
        id: "moveIn",
        actionStatus: globalState?.flowIdInfo?.move_in_status,
        button_text: globalState?.flowIdInfo?.move_in_button_text,
        navigate: () => navigation.navigate("DepositInfo")
      },
      {
        buttonStatus: "property_status",
        routeKey: "DepositProtection",
        id: "depositProtect-HomeSetUp",
        actionStatus: globalState?.flowIdInfo?.property_status,
        button_text: globalState?.flowIdInfo?.verification_button_text,
        navigate: () => navigation.navigate("DepositProtection")
      },
    ];

    let filterList = ListArray.filter((data, indes) => data?.actionStatus === 5);
    setFilterButton(filterList.reverse());

    if (globalState?.preQualData?.preQualStatus) {
      setPreQualData(globalState?.preQualData?.preQualStatus);
    }
  }, [globalState]);

  useEffect(() => {
    if (profile && profile?.data) {
      if (profile?.data?.tdkToken?.user_id) {
        setTdsRoute("Custodial Tenancies");
      } else {
        console.log("tdsLocationSelected", tdsLocationSelected)
        setTdsRoute(tdsLocationSelected ? tdsLocationSelected == "TDS_NI" ? "tdsLocation" : tdsLocationSelected : "tdsLocation");
      }
    } else {
      setTdsRoute(tdsLocationSelected ? tdsLocationSelected == "TDS_NI" ? "tdsLocation" : tdsLocationSelected : "tdsLocation");
    }
  }, [profile]);

  const getIdVerificationStatus = () => {
    switch (id_verification?.idverification) {
      case 2:
        return 'Completed';
        break;
      case 9:
        return 'Failed';
        break;
      case 1:
        return 'Pending';
        break;
      default:
        return null;
        break;
    }
  };

  const renderIDVerStatus = () => {
    if (id_verification?.idverification == 2) {
      return 2
    } else if (id_verification?.idverification == 9) {
      return 0
    } else if (id_verification?.idverification == 1 || id_verification?.payment_required == false) {
      return 1
    } else {
      return 0
    }
  };
  const _onSignup = () => {
    const {
      buyerFirstName = "",
      buyerMobile = "",
      buyerLastName = "",
      tenancy_reg_status = ""
    } = state;

    let firstNameCheck = NameValidation(buyerFirstName);
    let lastNameCheck = NameValidation(buyerLastName);
    let mobileCheck = MobileValidation(buyerMobile);
    let tenancy_reg_statusCheck = NameValidation(tenancy_reg_status);


    if (
      mobileCheck.status &&
      firstNameCheck.status &&
      lastNameCheck.status &&
      tenancy_reg_statusCheck.status
    ) {
      setState({
        ...state,
        validateCheckbox: false,
      });
      updateData(buyerFirstName, buyerLastName, buyerMobile, tenancy_reg_status)
    } else {
      setState({
        ...state,
        buyerFirstNameErrorMsg: buyerFirstName ? "" : "This is a required field",
        buyerLastNameErrorMsg: buyerLastName ? "" : "This is a required field",
        buyerMobileErrorMsg: mobileCheck.status ? "" : mobileCheck.msg,
        tenancy_reg_statusMsg: tenancy_reg_status ? "" : "This is a required field"
      });
    }
  };
  const updateData = async (buyerFirstName, buyerLastName, buyerMobile, tenancy_reg_status) => {
    const payload = {
      user: {
        first_name: buyerFirstName,
        last_name: buyerLastName,
        contact_number: buyerMobile,
        user_id: profile?.data?.user_id,
        user_type: 0,
        is_tenant_concierge_service: state.is_tenant_concierge_service,
        tenancy_reg_status: tenancy_reg_status,
        title: '',
        address: addressLine1 + ', ' + addressLine2 + ', ' + city,
        postcode: selectedPostcode
      }
    };
    const { buyerEmail, buyerPassword } = state;

    dispatch(
      updateProfile(payload, (cb) => {
        dispatch(getProfile((data) => {
          if (data?.subscription_selection_required) {
            navigation.reset({
              index: 0,
              routes: [{ name: 'TlyfePlans', params: { onRegistration: true } }],
            });
          }
        }))
      })
    );
  };
  const handleAddressSelection = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      const addressObj = JSON.parse(selectedOption.value);
      setSelectedAddress(addressObj);

      // Populate address fields
      const line1 = [addressObj.SUB_BUILDING, addressObj.BUILDING_NAME].filter(Boolean).join(', ');
      const line2 = addressObj.STREET_NAME || '';

      setAddressLine1(line1 ? line1 : line2);
      setAddressLine2(line2);
      setCity(addressObj.TOWN_NAME || '');
      setSelectedPostcode(addressObj.POSTCODE || '');

      // Clear any error messages
      setAddressLine1ErrorMsg("");
      setCityErrorMsg("");
      setSelectedPostcodeErrorMsg("");
    }
  };

  const registerView = () => {
    const {
      buyerFirstNameErrorMsg,
      buyerMobileErrorMsg,
      buyerLastNameErrorMsg,
      is_tenant_concierge_service,
      tenancy_reg_statusMsg,
      tenancy_reg_status
    } = state;

    return (
      <RegisterCard>
        <ODSText textAlign="center" type="h3" color={colors.text.secondary}>
          Complete Registration
        </ODSText>
        <View style={{ marginTop: 32, gap: 32 }}>
          <View style={{ flexDirection: layout == "phone" ? 'column' : 'row', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, zIndex: 10000 }}>
            <ODSInput
              label="First Name*"
              placeholder="first name"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={state?.buyerFirstName}
              onChange={(firstName) => {
                Regex.validateWithSpecialName(firstName) &&
                  setState({
                    ...state,
                    buyerFirstName: firstName,
                    buyerFirstNameErrorMsg: "",
                  });
              }}
              hints={buyerFirstNameErrorMsg == "" ? [] : [{ hint: buyerFirstNameErrorMsg, state: 'error' }]}
            />
            <ODSInput
              label="Last Name*"
              placeholder="last name"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={state?.buyerLastName}
              onChange={(lastName) =>
                Regex.validateWithSpecialName(lastName) &&
                setState({
                  ...state,
                  buyerLastName: lastName,
                  buyerLastNameErrorMsg: "",
                })
              }
              hints={buyerLastNameErrorMsg == "" ? [] : [{ hint: buyerLastNameErrorMsg, state: 'error' }]}
            />
            <ODSInput
              label="Contact number*"
              placeholder="contact"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={state?.buyerMobile}
              onChange={(mobile) => {
                const numericValue = mobile.replace(/[^0-9]/g, '');
                setState({
                  ...state,
                  buyerMobile: numericValue,
                  buyerMobileErrorMsg: "",
                })
              }}
              keyboardType="number-pad"
              hints={buyerMobileErrorMsg == "" ? [] : [{ hint: buyerMobileErrorMsg, state: 'error' }]}
            />
            <View style={{ width: layout == 'phone' ? '100%' : 259 }}>
              <ODSCombobox
                width={"100%"}
                onChange={(value) => {
                  setState({
                    ...state,
                    buyerEmailErrorMsg: "",
                    tenancy_reg_statusMsg: "",
                    tenancy_reg_status: value.value
                  })
                }}
                hints={tenancy_reg_statusMsg == "" ? [] : [{ hint: tenancy_reg_statusMsg, state: 'error' }]}
                placeholder={tenancy_reg_status ? tenancy_reg_status : ''}
                label="What is your tenancy status? *"
                data={
                  tenancy_status && tenancy_status.length
                    ? tenancy_status.map((salutation) => {
                      return { value: salutation.key, label: salutation.name };
                    })
                    : []
                }
              />
            </View>

            {/* Postcode lookup section */}
            <View style={{ width: layout == 'phone' ? '100%' : '100%', marginTop: 20, zIndex: -11 }}>
              <ODSText type="md-bold" color={colors.text.secondary} marginBottom={8}>
                Please add the tenancy address below
              </ODSText>
              <View style={{ flexDirection: layout == 'phone' ? 'row' : 'row', alignItems: 'flex-end', gap: 12, flex: 1 }}>
                <ODSInput
                  label="Postcode"
                  placeholder="Enter postcode"
                  style={{ width: layout == 'phone' ? '100%' : 259 }}
                  value={postcode}
                  onChange={(value) => setPostcode(value)}
                  hints={postcodeErrorMsg == "" ? [] : [{ hint: postcodeErrorMsg, state: 'error' }]}
                />
                <ODSButton
                  themeColor={colors.main.purple}
                  type="primary"
                  restStyle={{ width: layout == 'phone' ? 120 : 150, height: 48 }}
                  onPress={() => {
                    const trimmed = postcode.trim();
                    if (!trimmed) {
                      setPostcodeErrorMsg("Please enter a postcode");
                      return;
                    }
                    if (trimmed.length < 6) {
                      setPostcodeErrorMsg("Postcode must be at least 6 characters");
                      return;
                    }
                    setPostcodeErrorMsg("");
                    dispatch(tenantActions.searchAddress(trimmed));
                  }}
                >
                  Search
                </ODSButton>
              </View>
            </View>

            {/* Address selection dropdown */}
            {postcodeData.length > 0 && <View style={{ width: layout == 'phone' ? '100%' : '100%', zIndex: 9999 }}>
              <ODSCombobox
                width={"100%"}
                onChange={(value) => handleAddressSelection(value)}
                placeholder="Select an address"
                label="Select Address"
                data={postcodeData || []}
              />
            </View>}

            {/* Address fields */}
            <ODSInput
              label="Address Line 1 *"
              placeholder="Address line 1"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={addressLine1}
              onChange={(value) => {
                setAddressLine1(value);
                setAddressLine1ErrorMsg("");
              }}
              hints={addressLine1ErrorMsg == "" ? [] : [{ hint: addressLine1ErrorMsg, state: 'error' }]}
            />

            <ODSInput
              label="Address Line 2"
              placeholder="Address line 2"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={addressLine2}
              onChange={(value) => setAddressLine2(value)}
            />

            <ODSInput
              label="City *"
              placeholder="City"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={city}
              onChange={(value) => {
                setCity(value);
                setCityErrorMsg("");
              }}
              hints={cityErrorMsg == "" ? [] : [{ hint: cityErrorMsg, state: 'error' }]}
            />

            <ODSInput
              label="Postcode *"
              placeholder="Postcode"
              style={{ width: layout == 'phone' ? '100%' : 259 }}
              value={selectedPostcode}
              onChange={(value) => {
                setSelectedPostcode(value);
                setSelectedPostcodeErrorMsg("");
              }}
              hints={selectedPostcodeErrorMsg == "" ? [] : [{ hint: selectedPostcodeErrorMsg, state: 'error' }]}
            />
          </View>

          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <ODSCheckbox checked={is_tenant_concierge_service} onPress={() =>
              setState({
                ...state,
                is_tenant_concierge_service: !state.is_tenant_concierge_service,
              })
            } />
            <View style={{ flexDirection: 'row', flexWrap: "wrap", flex: 1 }}>
              <ODSText marginLeft={8} type="sm" color={colors.text.secondary}>
                I wish to have access to the free Home setup concierge service, to help with my tenancy{" "}
                <TouchableOpacity onPress={() => window.open("https://tlyfe.co.uk/homesetup", '_blank')}>
                  <ODSText textDecorationLine="underline" type="md-bold" color={colors.main.purple[700]}>
                    (Terms apply)
                  </ODSText>
                </TouchableOpacity>
              </ODSText>
            </View>
          </View>
          <ODSButton
            themeColor={colors.main.purple}
            type="primary"
            disabled={false}
            restStyle={{ width: 250, alignSelf: 'center', marginTop: 20 }}
            onPress={() => {
              const {
                buyerFirstName = "",
                buyerMobile = "",
                buyerLastName = "",
                tenancy_reg_status = ""
              } = state;

              let isValid = true;
              let firstNameCheck = NameValidation(buyerFirstName);
              if (!firstNameCheck.status) {
                setState(prev => ({
                  ...prev,
                  buyerFirstNameErrorMsg:
                    buyerFirstName ? firstNameCheck.msg : "This is a required field",
                }));
                isValid = false;
              }

              let lastNameCheck = NameValidation(buyerLastName);
              if (!lastNameCheck.status) {
                setState(prev => ({
                  ...prev,
                  buyerLastNameErrorMsg:
                    buyerLastName ? lastNameCheck.msg : "This is a required field",
                }));
                isValid = false;
              }

              let mobileCheck = MobileValidation(buyerMobile);
              if (!mobileCheck.status) {
                setState(prev => ({
                  ...prev,
                  buyerMobileErrorMsg: mobileCheck.msg,
                }));
                isValid = false;
              }

              if (!tenancy_reg_status) {
                setState(prev => ({
                  ...prev,
                  tenancy_reg_statusMsg: "This is a required field",
                }));
                isValid = false;
              }

              if (!addressLine1) {
                setAddressLine1ErrorMsg("Address line 1 is required");
                isValid = false;
              }

              if (!city) {
                setCityErrorMsg("City is required");
                isValid = false;
              }

              if (!selectedPostcode) {
                setSelectedPostcodeErrorMsg("Postcode is required");
                isValid = false;
              }
              if (isValid) {
                _onSignup();
              }
            }}

          >
            Complete
          </ODSButton>
        </View>
      </RegisterCard>
    );
  };

  if (profile?.data?.profile_completion_required) {
    return (
      <Wrapper
        theme={colors.transparency.purple}
        type="plans"
        drawerColor={colors.theme.purple}
        showLogout={true}
        onLogoutClick={() => setShowLogoutPopup(true)}
        headerImage={layout == 'web' ? HeaderWeb : layout == 'tab' ? HeaderTab : HeaderMobile}
      // footerImage={layout == 'web' ? FooterWeb : layout == 'tab' ? FooterTab : FooterMobile}
      >
        {registerView()}
        <CustomPopUp
          loading={showLogoutPopup}
          primaryButtonText={"Sure"}
          secondaryButtonText={"cancel"}
          primaryText={"Logout?"}
          secondaryText={" Are you sure you want to logout?"}
          onPrimaryButtonPress={() => {
            trackLogout();
            setShowLogoutPopup(false);
            dispatch(LogoutApi(false, navigation))
          }}
          onSecondaryButtonPress={() => {
            setShowLogoutPopup(false);
          }}
        />
      </Wrapper>
    );
  }

  if (!profileChecked) {
    return null;
  }

  return (
    <BackGroundGenerator isTLYF props={props}>
      <ImageBackground
        source={
          getImage("dashboard.png")
        }
        style={{
          width: '100%',
          height: '270px',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
        resizeMode="cover"
      ></ImageBackground>
      <View
        style={{ marginTop: layout == 'phone' ? -120 : -150, zIndex: 1000, width: '100%', flexDirection: layout == "phone" ? 'column' : 'row', alignSelf: 'center', justifyContent: 'center', alignItems: layout !== "phone" ? 'center' : undefined, gap: 20 }}
      >
        <ODSWelcomeTile
          title={profile && `Welcome ${profile?.data.first_name}!`}
          // subtitle={'Check out your latest updates below!'}
          onPress={() => navigateAction(navigation, profile?.data?.isActiveOpenflow ? "My Tenancy Home" : tdsRoute)}
          registerForm={isLoginTypeTds}
          isActiveOpenflow={profile?.data?.isActiveOpenflow}

          navigationRoutes={[
            {
              id: 'MyDocuments',
              route: 'Document Share Center',
            },
            {
              id: 'OpenFlow',
              route: 'My Tenancy Home',
            },
            {
              id: 'CreditBuilder',
              route: 'Credit Builder',
              status: userData?.creditladder_code == "" ? null : userData?.creditladder_code != "expired" ? "Completed" : "Expired",
            },
            {
              id: 'TenancyDeposit',
              route: tdsRoute,
            },
            {
              id: 'PreQualification',
              route: 'PreQualification',
            },
            {
              id: 'IDVerification',
              route: 'PreQualificationIdAndVerification',
              status: id_verification?.idverification && getIdVerificationStatus(),
            },
            {
              id: 'Rewards',
              route: 'Rewards',
            },
            {
              id: 'Insurance',
              route: 'TenantInsurance',
            },
            {
              id: 'TlyfeProtect',
              route: 'TlyfeProtect',
            },
            {
              id: 'IncomeProtection',
              route: 'IncomeProtection',
            },
            {
              id: 'HomeContentsInsurance',
              route: 'HomeContentsInsurance',
            }
          ]}
          rentReadyData={[{
            title: "Affordability",
            state: affordability?.affordability_amount ? 2 : 0,
            onPress: () => {
              navigateAction(navigation, "PreQualificationAffordability")
            }

          },
          {
            title: "Tenant Info",
            state: (tenant_info?.occupation || tenant_info?.marital_status) ? 2 : 0,
            onPress: () => {
              navigateAction(navigation, "PreQualificationTenantInfo")
            }
          },
          {
            title: "Right to Rent",
            state: right_to_rent?.right_to_rent_dob && right_to_rent?.right_to_rent_dob !== 'N/A' && right_to_rent?.right_to_rent_dob !== null ? 2 : 0,
            onPress: () => {
              navigateAction(navigation, "PreQualificationRightToRent")
            }
          },
          {
            title: "ID Verification",
            state: renderIDVerStatus(),
            onPress: () => {
              navigateAction(navigation, "PreQualificationIdAndVerification")
            }
          }, {
            title: "Rent Ready Reference",
            state: fcc_pre_reference?.status == 'completed' ? 2 : (fcc_pre_reference?.status == 'in_progress' || fcc_pre_reference?.payment_required == false) ? 1 : 0,
            onPress: () => {
              navigateAction(navigation, "PreQualificationPreReference")
            }
          }]}
          navigation={navigation}
          loading={!profile || !profile.data}
        />
        {/* <View style={{ paddingHorizontal: layout == "phone" ? '2%' : 0 }}>
          <ODSHomeIframe
            navigation={navigation}
            iFrameParams={iFrameParams}
            homeBaseUrl={HOME_BASE_URL}
            onHomeTilePressed={() => buttonPressEvent("Home Tile Pressed", "Dashboard")}
          /> 
        </View>*/}
      </View>

      {
        tiles.length > 0 && (
          <ODSDashboardTiles
            onMarketplacePressed={() => buttonPressEvent("Marketplace Pressed", "Dashboard")}
            housingGatewayPressed={() => buttonPressEvent("Housing Gateway Pressed", "Dashboard")}
            onHomeTilePressed={() => buttonPressEvent("Home Tile Pressed", "Dashboard")}
            homeBaseUrl={HOME_BASE_URL}
            isFccUser={profile?.data?.appUser?.primary_tag === "FCCPS" ? true : false}
            navigationRoutes={[
              {
                id: 'MyDocuments',
                route: 'Document Share Center',
              },
              {
                id: 'OpenFlow',
                route: 'My Tenancy Home',
              },
              {
                id: 'CreditBuilder',
                route: 'Credit Builder',
                status: userData?.creditladder_code == "" ? null : userData?.creditladder_code != "expired" ? "Completed" : "Expired",
              },
              {
                id: 'TenancyDeposit',
                route: tdsRoute,
              },
              {
                id: 'PreQualification',
                route: 'PreQualification',
              },
              {
                id: 'IDVerification',
                route: 'PreQualificationIdAndVerification',
                status: id_verification?.idverification && getIdVerificationStatus(),
              },
              {
                id: 'Rewards',
                route: 'Rewards',
              },
              {
                id: 'Insurance',
                route: 'TenantInsurance',
              },
              {
                id: 'TlyfeProtect',
                route: 'TlyfeProtect',
              },
              {
                id: 'IncomeProtection',
                route: 'IncomeProtection',
              },
              {
                id: 'HomeContentsInsurance',
                route: 'HomeContentsInsurance',
              },
              {
                id: 'InfoHub',
                route: 'MediaHub'
              },
              {
                id: 'MarketPlace',
                route: 'Marketplace'
              }
            ]}
            rentReadyData={[{
              title: "Affordability",
              state: affordability?.affordability_amount ? 2 : 0,
              onPress: () => {
                navigateAction(navigation, "PreQualificationAffordability")
              }

            },
            {
              title: "Tenant Info",
              state: (tenant_info?.occupation || tenant_info?.marital_status) ? 2 : 0,
              onPress: () => {
                navigateAction(navigation, "PreQualificationTenantInfo")
              }
            },
            {
              title: "Right to Rent",
              state: right_to_rent?.right_to_rent_dob && right_to_rent?.right_to_rent_dob !== 'N/A' && right_to_rent?.right_to_rent_dob !== null ? 2 : 0,
              onPress: () => {
                navigateAction(navigation, "PreQualificationRightToRent")
              }
            },
            {
              title: "ID Verification",
              state: renderIDVerStatus(),
              onPress: () => {
                navigateAction(navigation, "PreQualificationIdAndVerification")
              }
            }, {
              title: "Rent Ready Reference",
              state: fcc_pre_reference?.status == 'completed' ? 2 : (fcc_pre_reference?.status == 'in_progress' || fcc_pre_reference?.payment_required == false) ? 1 : 0,
              onPress: () => {
                navigateAction(navigation, "PreQualificationPreReference")
              }
            }]}
            navigation={navigation}
            tiles={tiles}
            iFrameParams={iFrameParams}
            isLoginTypeTds={isLoginTypeTds}
            renderTenancyTile={<ODSTenancyTile
              movedIn={flowIdInfo?.percentage_completed == 100 ? true : false}
              actionButtons={filterButton}
              percentage={flowIdInfo?.percentage_completed || 0}
              actionRequired={flowIdInfo?.percentage_completed > 0 && flowIdInfo?.percentage_completed <= 99 && filterButton && true}
              onPress={() => {
                navigateAction(navigation, "My Tenancy Home")
                buttonPressEvent("My Tenancy Home", "Dashboard")
              }}
            />}
          />
        )
      }
      <AppBanner />
    </BackGroundGenerator >
  );
};

export default Dashboard;
